import { css } from 'astroturf';
import React from 'react';

const styles = css`
  .mobileprice {
    position: fixed;
    z-index: 2;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column-reverse;
    height: 57px;

    @media (min-width: 60rem) {
      display: none;
    }

    &::before {
      content: '';
      position: fixed;
      inset: 0;
      opacity: 0;
      pointer-events: none;
      background: #0c628d;
      transition: 0.25s ease-in-out opacity;
    }

    &.active::before {
      opacity: 0.33;
      pointer-events: all;
    }

    table {
      padding: 1rem 1.5rem;
      z-index: 1;
      border: 0;
      position: relative;
      background: #fff;
      width: 100%;
      translate: 0 100%;
      transition: 0.25s ease-in-out translate;
      border-top: 1px solid #0c628d66;
      font-variant-numeric: tabular-nums;

      tr {
        max-width: 400px;
        margin: 0 auto;
        padding: 0 0rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #0c628d22;

        &:last-child {
          border-bottom: 0;
        }
      }

      tr:last-child {
        color: color-mix(in hsl, currentColor 60%, transparent);
      }
      th {
        padding: 1rem 0;
        text-align: left;
        font-weight: 500;
      }
      td {
        text-align: right;
        min-width: 5.5rem;
      }
      .unitPrice {
        color: color-mix(in hsl, currentColor 60%, transparent);
      }

      .seatSelect {
        font: inherit;
        font-weight: 700;
        font-size: 1rem;
        color: #fff;
        background-color: #0c628d;
        border: 1px solid #0c628d;
        border-radius: 0.3rem;
        width: 6.5rem;
        padding: 0.2rem 1.3rem 0.2rem 0.5rem;
        cursor: pointer;
        appearance: none;
        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 0.5rem center;
        background-size: 0.55rem;
        transition: 0.15s ease-in-out background-color;

        &:hocus {
          background-color: #094e70;
        }

        option {
          color: #113;
          background: #fff;
          font-weight: 400;
        }
      }

      .seatLocked {
        display: inline-block;
        font-weight: 700;
      }
    }

    &.active table {
      translate: 0 0;
    }

    .total {
      font-size: 1rem;
      position: relative;
      background: #fff;
      border: 0;
      border-top: 1px solid #0c628d44;
      padding: 1rem 1.5rem;
      z-index: 2;
      width: 100%;

      > div {
        width: 100%;
        max-width: 400px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
      }

      span {
        margin-left: auto;
      }

      em {
        margin-left: 0.5rem;
        font-style: normal;
        font-weight: normal;
      }
    }

    .toggle {
      width: 1.5rem;
      height: 1.5rem;
      color: #0008;
      color: oklch(0.551 0.027 264.364);
      display: grid;
      place-items: center;
      transition: 0.15s ease-in-out transform;
    }
    &.active .toggle {
      transform: rotate(-180deg);
    }

    .note {
      text-align: left;
      line-height: 1.25;
      padding: 0.5rem 0;
      font-size: 0.875rem;
      opacity: 1;
      interpolate-size: allow-keywords;
      height: auto;
      transition:
        0.25s ease-in-out opacity,
        0.25s ease-in-out height;

      &[aria-hidden='true'] {
        opacity: 0;
        height: 0;
      }
    }
  }
`;

class MobilePrice extends React.Component {
  constructor() {
    super();
    this.state = {
      overview: false,
    };
  }

  toggleOverview = () => {
    this.setState((prevState) => ({
      overview: !prevState.overview,
    }));
  };

  render() {
    const {
      total,
      subtotal,
      hasSeats,
      quantity,
      minSeats,
      maxSeats,
      unitPrice,
      seatsLocked,
      onQuantityChange,
      coupon,
      discount,
      hasVat,
      vat,
      taxrate,
      duration,
    } = this.props;
    const durationText = duration === 'year' ? 'yearly' : 'monthly';

    return (
      <div className={[styles.mobileprice, this.state.overview ? styles.active : ''].join(' ')}>
        <button type="button" className={styles.total} onClick={this.toggleOverview}>
          <div>
            <b>
              Total <em>{durationText}</em>
            </b>
            <span>{total}</span>
            <div className={styles.toggle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="icon icon-tabler icon-tabler-chevron-down"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="6 9 12 15 18 9" />
              </svg>
            </div>
          </div>
        </button>
        <table>
          <tr>
            <th>
              {hasSeats ? (
                <>
                  {seatsLocked ? (
                    <span className={styles.seatLocked}>
                      {quantity} seat{quantity === 1 ? '' : 's'}
                    </span>
                  ) : (
                    <select
                      className={styles.seatSelect}
                      aria-label="Number of seats"
                      value={quantity}
                      onChange={onQuantityChange}
                    >
                      {Array.from({ length: maxSeats - minSeats + 1 }, (_, i) => minSeats + i).map((n) => (
                        <option key={n} value={n}>
                          {n} seat{n === 1 ? '' : 's'}
                        </option>
                      ))}
                    </select>
                  )}{' '}
                </>
              ) : (
                'Subtotal'
              )}
            </th>
            <td>{subtotal}</td>
          </tr>
          {coupon ? (
            <tr>
              <th>Discount code {discount ? '' : <small>not yet applied</small>}</th>
              <td>{discount || `${coupon.slice(coupon.length - 2)}%`}</td>
            </tr>
          ) : null}
          <tr>
            <th>Sales tax {hasVat && taxrate ? <>({taxrate}%)</> : ''}</th>
            <td>{vat}</td>
          </tr>
          <tr>
            <td colSpan={2} className={styles.note} aria-hidden={!hasVat}>
              <em>Tax may be deducted after filling in company details.</em>
            </td>
          </tr>
        </table>
      </div>
    );
  }
}

export default MobilePrice;
